/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUserGroup201Response,
  CreateUserGroupAssignment201Response,
  FindAllUserDynamicPermissions200Response,
  FindAllUserFacilityAccess200Response,
  FindAllUserGroups200Response,
  FindAllUsersV2200Response,
  SetUserDynamicPermissionsRequest,
  UpdateUserFacilityAccessRequest,
  UpdateUserPin,
  UserCrmNotificationStatus,
  UserGroup,
  UserGroupAssignment,
} from '../models/index';
import {
    CreateUserGroup201ResponseFromJSON,
    CreateUserGroup201ResponseToJSON,
    CreateUserGroupAssignment201ResponseFromJSON,
    CreateUserGroupAssignment201ResponseToJSON,
    FindAllUserDynamicPermissions200ResponseFromJSON,
    FindAllUserDynamicPermissions200ResponseToJSON,
    FindAllUserFacilityAccess200ResponseFromJSON,
    FindAllUserFacilityAccess200ResponseToJSON,
    FindAllUserGroups200ResponseFromJSON,
    FindAllUserGroups200ResponseToJSON,
    FindAllUsersV2200ResponseFromJSON,
    FindAllUsersV2200ResponseToJSON,
    SetUserDynamicPermissionsRequestFromJSON,
    SetUserDynamicPermissionsRequestToJSON,
    UpdateUserFacilityAccessRequestFromJSON,
    UpdateUserFacilityAccessRequestToJSON,
    UpdateUserPinFromJSON,
    UpdateUserPinToJSON,
    UserCrmNotificationStatusFromJSON,
    UserCrmNotificationStatusToJSON,
    UserGroupFromJSON,
    UserGroupToJSON,
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentToJSON,
} from '../models/index';

export interface CreateUserGroupRequest {
    userGroup: UserGroup;
}

export interface CreateUserGroupAssignmentRequest {
    userGroupAssignment: UserGroupAssignment;
}

export interface DeleteUserRequest {
    id: string;
    pin: string;
    newTaskUserId?: string;
    newProspectUserId?: string;
}

export interface DeleteUserGroupRequest {
    id: string;
}

export interface DeleteUserGroupAssignmentRequest {
    id: string;
}

export interface FindAllUserDynamicPermissionsRequest {
    id: string;
}

export interface FindAllUserFacilityAccessRequest {
    id: string;
}

export interface FindAllUserGroupsRequest {
    facilityId?: string;
}

export interface FindAllUsersV2Request {
    page?: number;
    limit?: number;
    facilityIds?: string;
    userTypeIds?: string;
    name?: string;
}

export interface FindOneUserGroupRequest {
    id: string;
    facilityId?: string;
}

export interface SetUserDynamicPermissionsOperationRequest {
    id: string;
    setUserDynamicPermissionsRequest: SetUserDynamicPermissionsRequest;
}

export interface UpdateUserCrmNotificationStatusRequest {
    id: string;
    userCrmNotificationStatus: UserCrmNotificationStatus;
}

export interface UpdateUserFacilityAccessOperationRequest {
    id: string;
    updateUserFacilityAccessRequest: UpdateUserFacilityAccessRequest;
}

export interface UpdateUserGroupRequest {
    id: string;
    userGroup: UserGroup;
}

export interface UpdateUserPinRequest {
    id: string;
    updateUserPin: UpdateUserPin;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Create a user group
     */
    async createUserGroupRaw(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.userGroup === null || requestParameters.userGroup === undefined) {
            throw new runtime.RequiredError('userGroup','Required parameter requestParameters.userGroup was null or undefined when calling createUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters.userGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group
     */
    async createUserGroup(requestParameters: CreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.createUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignmentRaw(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroupAssignment201Response>> {
        if (requestParameters.userGroupAssignment === null || requestParameters.userGroupAssignment === undefined) {
            throw new runtime.RequiredError('userGroupAssignment','Required parameter requestParameters.userGroupAssignment was null or undefined when calling createUserGroupAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-group-assignments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupAssignmentToJSON(requestParameters.userGroupAssignment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroupAssignment201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a user group assignment
     */
    async createUserGroupAssignment(requestParameters: CreateUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroupAssignment201Response> {
        const response = await this.createUserGroupAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a user
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUser.');
        }

        if (requestParameters.pin === null || requestParameters.pin === undefined) {
            throw new runtime.RequiredError('pin','Required parameter requestParameters.pin was null or undefined when calling deleteUser.');
        }

        const queryParameters: any = {};

        if (requestParameters.pin !== undefined) {
            queryParameters['pin'] = requestParameters.pin;
        }

        if (requestParameters.newTaskUserId !== undefined) {
            queryParameters['new_task_user_id'] = requestParameters.newTaskUserId;
        }

        if (requestParameters.newProspectUserId !== undefined) {
            queryParameters['new_prospect_user_id'] = requestParameters.newProspectUserId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a user
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user group
     */
    async deleteUserGroupRaw(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group
     */
    async deleteUserGroup(requestParameters: DeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignmentRaw(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUserGroupAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-group-assignments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user group assignment
     */
    async deleteUserGroupAssignment(requestParameters: DeleteUserGroupAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserGroupAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissionsRaw(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserDynamicPermissions200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findAllUserDynamicPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}/dynamic-permissions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserDynamicPermissions200ResponseFromJSON(jsonValue));
    }

    /**
     * List all dynamic permissions for a user
     */
    async findAllUserDynamicPermissions(requestParameters: FindAllUserDynamicPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserDynamicPermissions200Response> {
        const response = await this.findAllUserDynamicPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccessRaw(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserFacilityAccess200Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findAllUserFacilityAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{id}/facility-access`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserFacilityAccess200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user facility access
     */
    async findAllUserFacilityAccess(requestParameters: FindAllUserFacilityAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserFacilityAccess200Response> {
        const response = await this.findAllUserFacilityAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all user groups
     */
    async findAllUserGroupsRaw(requestParameters: FindAllUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUserGroups200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUserGroups200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all user groups
     */
    async findAllUserGroups(requestParameters: FindAllUserGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUserGroups200Response> {
        const response = await this.findAllUserGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get All Users
     */
    async findAllUsersV2Raw(requestParameters: FindAllUsersV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllUsersV2200Response>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.facilityIds !== undefined) {
            queryParameters['facility_ids'] = requestParameters.facilityIds;
        }

        if (requestParameters.userTypeIds !== undefined) {
            queryParameters['user_type_ids'] = requestParameters.userTypeIds;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllUsersV2200ResponseFromJSON(jsonValue));
    }

    /**
     * Get All Users
     */
    async findAllUsersV2(requestParameters: FindAllUsersV2Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllUsersV2200Response> {
        const response = await this.findAllUsersV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find one user group
     */
    async findOneUserGroupRaw(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneUserGroup.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Find one user group
     */
    async findOneUserGroup(requestParameters: FindOneUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.findOneUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissionsRaw(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling setUserDynamicPermissions.');
        }

        if (requestParameters.setUserDynamicPermissionsRequest === null || requestParameters.setUserDynamicPermissionsRequest === undefined) {
            throw new runtime.RequiredError('setUserDynamicPermissionsRequest','Required parameter requestParameters.setUserDynamicPermissionsRequest was null or undefined when calling setUserDynamicPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/dynamic-permissions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserDynamicPermissionsRequestToJSON(requestParameters.setUserDynamicPermissionsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set users dynamic permissions
     */
    async setUserDynamicPermissions(requestParameters: SetUserDynamicPermissionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setUserDynamicPermissionsRaw(requestParameters, initOverrides);
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatusRaw(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserCrmNotificationStatus.');
        }

        if (requestParameters.userCrmNotificationStatus === null || requestParameters.userCrmNotificationStatus === undefined) {
            throw new runtime.RequiredError('userCrmNotificationStatus','Required parameter requestParameters.userCrmNotificationStatus was null or undefined when calling updateUserCrmNotificationStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/crm-notifications`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserCrmNotificationStatusToJSON(requestParameters.userCrmNotificationStatus),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a users crm notification status
     */
    async updateUserCrmNotificationStatus(requestParameters: UpdateUserCrmNotificationStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserCrmNotificationStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccessRaw(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserFacilityAccess.');
        }

        if (requestParameters.updateUserFacilityAccessRequest === null || requestParameters.updateUserFacilityAccessRequest === undefined) {
            throw new runtime.RequiredError('updateUserFacilityAccessRequest','Required parameter requestParameters.updateUserFacilityAccessRequest was null or undefined when calling updateUserFacilityAccess.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/facility-access`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserFacilityAccessRequestToJSON(requestParameters.updateUserFacilityAccessRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Grant or revoke user access to facilities
     */
    async updateUserFacilityAccess(requestParameters: UpdateUserFacilityAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserFacilityAccessRaw(requestParameters, initOverrides);
    }

    /**
     * Update user group
     */
    async updateUserGroupRaw(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUserGroup201Response>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserGroup.');
        }

        if (requestParameters.userGroup === null || requestParameters.userGroup === undefined) {
            throw new runtime.RequiredError('userGroup','Required parameter requestParameters.userGroup was null or undefined when calling updateUserGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user-groups/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupToJSON(requestParameters.userGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUserGroup201ResponseFromJSON(jsonValue));
    }

    /**
     * Update user group
     */
    async updateUserGroup(requestParameters: UpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUserGroup201Response> {
        const response = await this.updateUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a users PIN
     */
    async updateUserPinRaw(requestParameters: UpdateUserPinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUserPin.');
        }

        if (requestParameters.updateUserPin === null || requestParameters.updateUserPin === undefined) {
            throw new runtime.RequiredError('updateUserPin','Required parameter requestParameters.updateUserPin was null or undefined when calling updateUserPin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{id}/user-pin`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserPinToJSON(requestParameters.updateUserPin),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a users PIN
     */
    async updateUserPin(requestParameters: UpdateUserPinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserPinRaw(requestParameters, initOverrides);
    }

}
